import { TeaserCardsLine } from 'Components/lines/teaser-cards-line/TeaserCardsLine';
export default TeaserCardsLine;
